import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useParams } from "react-router-dom";
import Navbar from './components/Navbar';
import { getWebClient } from '../helpers/Helpers.js';

export default function MacroregioniDettagli() {

    const { id } = useParams();
    const client = getWebClient();
    const navigate = useNavigate();

    const [labels, setLabels] = useState();
    const [model, setModel] = useState({ id: uuidv4(), nome: '' });
    const [deleteButton, setDeleteButton] = useState('');

    useEffect(() => {

        if (id === 'new') {

            setLabels({
                "title": "Creazione nuova macroregione",
                "submitButtonText": "Crea la macroregione",
            });

            setModel({ id: uuidv4(), nome: '' });


        } else {

            setLabels({
                "title": "Dettagli della macroregione",
                "submitButtonText": "Modifica la macroregione",
            });

            setDeleteButton(<button type="button" className="btn btn-primary" style={{ marginTop: 40, marginLeft: 10 }} onClick={handleDeleteStep1}>Elimina la macroregione</button>);

            const macroregioniGetPromise = client.get(`/api/macroregioni/${id}`).then((response) => {
                setModel(response.data);
            });

            Promise.all([macroregioniGetPromise]).catch(function (err) {
                console.log(err);
            });

        }

    }, []);

    const handleDeleteStep1 = (event) => {

        setDeleteButton(
            <div className="btn-group" role="group" style={{ marginTop: 40, marginLeft: 10 }}>
                <button type="button" className="btn btn-primary" onClick={handleDeleteUndo}>Annulla</button>
                <button type="button" className="btn btn-danger" onClick={handleDeleteStep2}>Procedi con l'eliminazione</button>
            </div>
        );

    }

    const handleDeleteStep2 = (event) => {

        client.delete(`/api/macroregioni/${id}`)
            .then(function (response) {
                navigate("/macroregioni");
            })
            .catch(function (error) {
                alert("Si sono verificati errori durante l'operazione di eliminazione. Riprovare in un secondo momento.");
            });

    }

    const handleDeleteUndo = (event) => {

        setDeleteButton(<button type="button" className="btn btn-primary" style={{ marginTop: 40, marginLeft: 10 }} onClick={handleDeleteStep1}>Elimina la macroregione</button>);

    }

    if (labels === undefined || model === undefined) { return; }

    return (
        <>

            <Navbar />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <h4>{labels.title}</h4>
            </div>

            <div className="container" style={{ marginBottom: 80 }}>

                <Formik

                    initialValues={model}
                    enableReinitialize="true"

                    validate={values => {

                        const errors = {};

                        document.getElementsByName('nome')[0].classList.remove("is-invalid")

                        if (!values.nome) {
                            errors.nome = <>Il campo Nome &egrave; richiesto</>;
                            document.getElementsByName('nome')[0].classList.add("is-invalid")
                        }

                        return errors;
                    }}

                    onSubmit={(values, { setSubmitting }) => {

                        if (id === 'new') {

                            client.post('/api/macroregioni', values)
                                .then(function (response) {
                                    navigate("/macroregioni");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        } else {

                            client.put('/api/macroregioni', values)
                                .then(function (response) {
                                    navigate("/macroregioni");
                                    setSubmitting(false);
                                })
                                .catch(function (error) {
                                    alert("Si sono verificati errori durante l'operazione di inserimento. Verificare i dati introdotti e riprovare.");
                                    setSubmitting(false);
                                });

                        }
                    }}
                >

                    {({ isSubmitting }) => (

                        <Form>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Id</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="id" readOnly="readonly" />
                                </div>
                            </div>

                            <div className="row mb-3">
                                <label htmlFor="id" className="col-sm-2 col-form-label">Nome</label>
                                <div className="col-sm-10">
                                    <Field className="form-control" type="text" name="nome" />
                                    <ErrorMessage className="invalid-feedback" name="nome" component="div" />
                                </div>
                            </div>

                            <button className="btn btn-primary" style={{ marginTop: 40 }} type="submit" disabled={isSubmitting}>{labels.submitButtonText}</button>
                            {deleteButton}

                        </Form>

                    )}

                </Formik>


            </div>

        </>
    )
}
